import update from 'react-addons-update'
import campaignService from 'services/campaigns-service'

// ------------------------------------
// Constants
// ------------------------------------
export const SET_CAMPAIGN_DETAILS = 'campaign/SET_CAMPAIGN_DETAILS'
export const SET_REPORT = 'campaign/SET_REPORT'
export const SET_COUNT_REPORT = 'campaign/SET_COUNT_REPORT'
export const SET_VIEWS = 'campaign/SET_VIEWS'
export const RESET_VIEW = 'campaign/RESET_VIEW'
export const SELECT_VIEW = 'campaign/SELECT_VIEW'

// ------------------------------------
// Actions
// ------------------------------------

export function setCampaign (payload) {
  return {
    type: SET_CAMPAIGN_DETAILS,
    payload: payload
  }
}

export function resetView () {
  return {
    type: RESET_VIEW
  }
}

function setReport (payload) {
  return {
    type: SET_REPORT,
    payload: payload
  }
}

function setCountReport (payload) {
  return {
    type: SET_COUNT_REPORT,
    payload: payload
  }
}

function setViews (payload) {
  return {
    type: SET_VIEWS,
    payload: payload
  }
}

export function selectView (payload) {
  return {
    type: SELECT_VIEW,
    payload: payload
  }
}

/*  This is a thunk, meaning it is a function that immediately
 returns a function for lazy evaluation. It is incredibly useful for
 creating async actions, especially when combined with redux-thunk!

 NOTE: This is solely for demonstration purposes. In a real application,
 you'd probably want to dispatch an action of COUNTER_DOUBLE and let the
 reducer take care of this logic.  */

// ------------------------------------
// Action Handlers
// ------------------------------------

export function downloadCsv (id, name, view, stores) {
  return campaignService.exportCampaignReport(id, name, view, stores)
}

export function loadReport (id, view, stores, page) {
  return (dispatch) => {
    campaignService.getReportForCampaign(id, view, stores, page)
      .then(res => {
        dispatch(setReport(res))
      })
      .catch(err => console.log(err))
  }
}

export function loadReportViewsMaster () {
  return (dispatch) => {
    campaignService.getReportViewsMaster()
      .then(res => {
        dispatch(setViews(res))
      })
      .catch(err => console.log(err))
  }
}

export function loadCountReport (id) {
  return (dispatch) => {
    campaignService.getCountReportForCampaign(id)
      .then(res => {
        dispatch(setCountReport(res))
      }).catch(err => console.log(err))
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

let defaultState = {
  viewsMaster: [],
  report: {
    view: {
      page: 0,
      hasMore: true,
      targets: []
    }
  },
  countReport: []
}

export default function reducer (state = defaultState, action) {
  let {type, payload} = action
  switch (type) {
    case SET_CAMPAIGN_DETAILS:
      return update(state, {
        report: {
          campaignId: { $set: payload.id },
          campaignName: { $set: payload.name },
          customers: { $set: payload.customers }
        }
      })
    case SET_REPORT:
      return update(state, {
        report: {
          view: {
            page: {$set: payload.page},
            hasMore: {$set: payload.hasMore},
            targets: {$push: payload.targets}
          }
        }
      })
    case SET_COUNT_REPORT:
      return update(state, { countReport: { $set: payload } })
    case SELECT_VIEW:
      return update(state, { selectedView: { $set: payload } })
    case SET_VIEWS:
      return update(state, { viewsMaster: { $set: payload } })
    case RESET_VIEW:
      return update(state, { report: { view: { $set: defaultState.report.view } } })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/Campaign/modules/campaign.js